export default "__VITE_ASSET__A8n2VbfC__"